import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useIntl } from "react-intl";
import Location from "../../../../assets/settings/Location.svg";
import Message from "../../../../assets/settings/Message.svg";
import Phone from "../../../../assets/settings/Phone.svg";

const Branch = ({ src, name, phone, mail, location, id, setId }: any) => {
  const intl = useIntl();
  const { locale } = intl;
  return (
    <div className="flex justify-between px-4 py-3 bg-white rounded-lg max-md:flex-col md:items-center max-md:gap-2">
      <div className="flex items-center justify-between w-full max-lg:mb-2">
        <div className="flex max-lg:flex-col max-lg:justify-center !items-center gap-2 w-full">
          <div className="flex items-center max-lg:w-full">
            <img
              className="w-full object-cover max-w-[300px]"
              src={src}
              alt=""
            />
          </div>
          <div className="flex items-center justify-start w-full gap-2">
            <span className="text-[#75757E] text-base max-lg:text-lg">
              {intl.formatMessage({ id: "branchNameLabel" })}
            </span>
            :
            <span className="text-[#020418] text-base max-lg:text-lg">
              {name}
            </span>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-end gap-4 max-lg:grid max-lg:justify-start w-fit whitespace-nowrap">
        <div className="flex items-center justify-end w-full gap-1 max-md:justify-start whitespace-nowrap">
          <img src={Phone} alt="salon name" />
          <span className="text-[#020418] text-sm " dir="ltr">
            {phone}
          </span>
        </div>
        <div className="flex items-center justify-end w-full gap-1 max-md:justify-start whitespace-nowrap">
          <img src={Message} alt="salon name" />
          <span className="text-[#020418] text-sm max-lg:text-base">
            {mail}
          </span>
        </div>
        <div className="flex items-center justify-end w-1/2 gap-1 max-md:justify-start max-lg:w-full whitespace-nowrap">
          <img src={Location} alt="salon name" />
          <span className="text-[#020418] text-sm max-lg:text-base">
            {location}
          </span>
        </div>
      </div>
      {locale === "ar" ? (
        <IoIosArrowBack
          onClick={() => setId(id)}
          className="mr-10 cursor-pointer w-9 h-9 max-md:mr-auto"
        />
      ) : (
        <IoIosArrowForward
          onClick={() => setId(id)}
          className="ml-10 cursor-pointer w-9 h-9 max-md:ml-auto"
        />
      )}
    </div>
  );
};

export default Branch;
